export const quoteType = {
  fcl: "fcl",
  lcl: "lcl",
  air: "air",
  ltl: "ltl",
  ftl: "ftl",
  ptl: "ptl",
  brokerage: "brokerage",
  manual: "manual",
  email: "email",
  airtariff: "airtariff",
  fclTariff: "fcltariff",
  multi: "multi",
};
